import React from "react";
import MainContainer from "../../styles/MainContainer.js";
import { StyledFooter } from "./FooterStyles.js";

function FooterContainer() {
	return (
		<MainContainer>
			<StyledFooter>
				{/* <p>Build with Gatsby.js</p> */}
				<p>Designed & Developed by 'Paras Arora'</p>
			</StyledFooter>
		</MainContainer>
	);
}

export default FooterContainer;
